import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import {
  getQueryStringFromObject,
  getTimestampWithTimezoneOffset,
  getTimezoneOffsetInHours,
} from '../../../../common/utils';
import { ExportsListStateModel } from './exports-list.state';
import { HttpResponse } from '@angular/common/http';
import { ExportDataSearchOutput } from '../models/exports.model';
import { ExportsEndpoint } from '../constants/exports-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ExportsListService {
  constructor(private http: WrapperHttpService) {}

  getExportsList(searchOutput: ExportDataSearchOutput): Observable<ExportsListStateModel> {
    const timezoneOffset: number = getTimezoneOffsetInHours(searchOutput.timezone);
    const { dateTimeRange, ...rest } = searchOutput.filter;
    const { start, end } = dateTimeRange;

    const params = getQueryStringFromObject({
      ...rest,
      createdFrom:
        getTimestampWithTimezoneOffset(start, timezoneOffset) ??
        getTimestampWithTimezoneOffset(new Date().getTime(), timezoneOffset),
      createdTo: getTimestampWithTimezoneOffset(end, timezoneOffset) ?? null,
    });

    const url = `${API_URL}${ExportsEndpoint.Base}?${params}`;
    return this.http.withLoading().get<ExportsListStateModel>(url);
  }

  downloadExportsFile(documentId: string): Observable<HttpResponse<Blob>> {
    const url = `${API_URL}${ExportsEndpoint.Base}${ExportsEndpoint.Files}/${documentId}`;
    return this.http.get<HttpResponse<Blob>>(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
